import { MantineProvider } from '@mantine/core';
import type { ReactNode } from 'react';
import { theme } from './theme';

/**
 * Color Scheme Provider
 *
 * Wraps MantineProvider with automatic dark mode support:
 * - Automatically follows system preference (light/dark)
 * - Updates in real-time when system preference changes
 * - Uses Mantine's default dark mode colors (optimized and tested)
 * - Manual toggle available via useMantineColorScheme hook
 */
export function ColorSchemeProvider({ children }: { children: ReactNode }) {
  return (
    <MantineProvider theme={theme} defaultColorScheme="auto">
      {children}
    </MantineProvider>
  );
}
